import React from 'react';
import './portal.css';

export interface CompanyInfo {
  name: string;
  domain: string;
  logo?: string;
  primaryColor?: string;
}

interface Props {
  companyInfo: CompanyInfo | null;
  children: React.ReactNode;
}

const PublicPortalLayout: React.FC<Props> = ({ companyInfo, children }) => {
  const primaryColor = companyInfo?.primaryColor || '#1a56db';

  return (
    <div className="portal-root" style={{ '--portal-primary': primaryColor } as React.CSSProperties}>
      <div className="portal-container">
        <header className="portal-header">
          <div className="portal-brand">
            {companyInfo?.logo ? (
              <img src={companyInfo.logo} alt={companyInfo.name} className="portal-logo" />
            ) : (
              <div className="portal-logo-placeholder">
                <span>{companyInfo?.name?.charAt(0) || 'C'}</span>
              </div>
            )}
            <div className="portal-brand-text">
              <span className="portal-company-name">{companyInfo?.name || 'Company'}</span>
              <span className="portal-brand-tag">Vehicle Portal</span>
            </div>
          </div>
        </header>

        <main className="portal-main">{children}</main>

        <footer className="portal-footer">
          <p>Powered by <strong>Scetru Fleet</strong></p>
        </footer>
      </div>
    </div>
  );
};

export default PublicPortalLayout;